import { Form, Select } from 'antd';
import { Langs } from '@/components';
import { UserScaleType } from '@/config';
import { useTranslation } from 'react-i18next';

type AppUserSizeType = {
  disabled: boolean;
  name?: string;
};

export const AppUserSize = ({ disabled = false, name = 'userSize' }) => {
  const { t } = useTranslation();
  return (
    <>
      <Form.Item
        name={name}
        label={<Langs title="tit_create_one_8" />}
        rules={[
          {
            required: true,
            message: <Langs title="tit_create_one_8" />,
          },
        ]}
      >
        <Select placeholder={t('develop_prefix_Placeholder7') as string} disabled={disabled}>
          {UserScaleType.map((items) => {
            return (
              <Select.Option value={items.value} key={items.id}>
                {items.label}
              </Select.Option>
            );
          })}
        </Select>
      </Form.Item>
    </>
  );
};
